module.exports = __webpack_public_path__ + "img/saoma.a5e8345c.png";